import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticleCards() {
  return (
    <section className="relative py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4">
            Shopping Guides
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-4">
            AllChinaBuySpreadsheet Shopping Guides &amp; Tips
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto">
            Expert guides to help you source smarter, avoid scams, and maximize your profits with China products.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2 flex-1">
                  {article.description}
                </p>
                <div className="flex flex-wrap gap-1.5 mb-3">
                  {article.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 text-[11px] font-medium rounded-full bg-secondary-100 text-secondary-700"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors mt-auto">
                  Read Article
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}